<template>
    <div class="container-fluid pt-section-fix" id="platform">
        <div class="row position-relative">
            <div class="col-12 col-md-3 col-xl-2 section-main-title">
                <div class="d-block d-md-inline-block main-background">ПЛАТФОРМА</div>
            </div>
            <div class="col-12 col-md-9 col-xl-10">
                <p>Платформата АдминПлюс се разработва и поддържа от фирма АдминСофт Плюс ООД. Тя е
                    специализирана дъщерна компания на фирма АдминСофт ООД, която от своя страна е първата
                    на пазара за училищна администрация в България и е с над 20 години опит и ноу хау в сферата
                    на българското образование. Основната цел и мисия на АдминСофт Плюс е разработване и
                    внедряване на облачни услуги, конкретно насочени към решения за нуждите на образованието.
                    Компанията е сертифицирана по международните стандарти ISO 9001, ISO 27001 и ISO 20000.</p>
                <p>АдминПлюс е облачна платформа, предназначена да подпомага и дигитализира работната
                    дейност на администрацията и учителите в детските градини и училищата. Спомага за
                    систематизирането на данните, за трайно намаляване на нуждите от хартиен ресурс, за
                    цялостно по-добро управление на училищния живот. Осигурява лесна и бърза дигитална
                    взаимовръзка между Училището и Родителите.</p>
                <p>Платформата е изградена на модулен принцип. Всеки модул отговаря за специфична
                    дейност, а всички заедно обхващат цялостния процес по въвеждане и обработка на данните и
                    предоставянето на информация на заинтересованите лица и институции.</p>
                <p><strong>АдминПлюс отговаря изцяло на действащата нормативна уредба.</strong></p>
                <div class="row">
                    <div class="col flex-grow-1 text-right">
                        <img src="../assets/img/iso_20000.svg" class="iso-icon">
                    </div>
                    <div class="col flex-sm-grow-0 flex-grow-1 text-right">
                        <img src="../assets/img/iso_9001_27001.svg" class="iso-icon">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "platform-component"
    }
</script>

<style scoped>
    .iso-icon {
        width: 200px;
    }
</style>
